import React, { memo, useReducer, useState } from 'react';
import { AdvanceFilter, Button, Table, Text } from 'components/src';
import {
  routesName,
  useDateChange,
  useGetAdminGetAllGroupsList,
  useNavigation,
} from 'core';
import { useTranslation } from 'react-i18next';
import { Flex, Space, Switch, TablePaginationConfig } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { RiDeleteBin6Line } from 'react-icons/ri';
import { CiEdit } from 'react-icons/ci';
import { PiNotebookLight } from 'react-icons/pi';
import {
  handleFiltering,
  initialState,
  reducer,
  updateCurrentPage,
} from './store';
interface Props {}

const GroupsList = memo<Props>(() => {
  const { _navigateWithParams } = useNavigation();
  const { i18n } = useTranslation();
  const { changeDateToPersian } = useDateChange();
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>(
    []
  );
  const [{ currentPage, showModal, advanceFilter }, dispatch] =
    useReducer(reducer, initialState);
  const { data, isFetching } = useGetAdminGetAllGroupsList({
    pageNumber: currentPage,
    pageSize: '10',
    groupName: advanceFilter.title,
  });

  const columns: any = [
    {
      title: i18n.t('id'),
      key: 'id',
      dataIndex: 'id',

      render: (text: any) => <Text>{text}</Text>,
    },
    {
      title: i18n.t('title'),
      dataIndex: 'title',
      key: 'title',
      render: (text: any) => <Text>{text}</Text>,
    },
    {
      title: i18n.t('created_at'),
      dataIndex: 'created_at',
      key: 'created_at',
      render: (text: any) => <Text>{changeDateToPersian(text)}</Text>,
    },
    {
      title: i18n.t('mandatory'),
      dataIndex: 'mandatory',
      key: 'mandatory',
      render: (text: any) => (text ? i18n.t('yes') : i18n.t('no')),
    },
    {
      title: i18n.t('operation'),
      key: 'operation',
      dataIndex: 'operation',
      render: (_: any, record: any) => (
        <Flex align="center" justify="start">
          <Space>
            <Button
              title={i18n.t('details')}
              customColor="warning"
              onClick={() => {
                _navigateWithParams(routesName.GROUPDETAIL, {
                  id: record.id,
                });
              }}
            >
              <PiNotebookLight size={20} />
            </Button>
            <Button
              title={i18n.t('edit')}
              onClick={() => {
                _navigateWithParams(routesName.EDITGROUP, {
                  id: record.id,
                });
              }}
            >
              <CiEdit size={20} />
            </Button>

            {/* <Switch
              checked={record.is_active}
              onChange={
                () => {}
                // update({
                //   campaign: record.id,
                //   requestBody: {},
                // })
              }
              checkedChildren={
                <Space style={{ marginTop: 3 }}>
                  <MdOutlineRemoveDone size={15} />
                </Space>
              }
              unCheckedChildren={
                <Space>
                  <IoCheckmarkDoneSharp size={15} />
                </Space>
              }
            /> */}
            {/* <Button
              title={i18n.t("delete")}
              color="danger"
              onClick={() => {
                dispatch(handleModal(true));
                dispatch(setId(record.id));
              }}
                disabled={isPending}
            >
              <RiDeleteBin6Line size={20} />
            </Button> */}
          </Space>
        </Flex>
      ),
    },
  ];

  const handleDownload = () => {
    // setStatisticDownload(true);
    // fetch(
    //   `https://autodialer.5040.me/api/statistic/excel/campaign-number-statistic`,
    //   {
    //     method: 'GET',
    //   }
    // )
    //   .then((response) => response.blob())
    //   .then((blob) => {
    //     downloadFile('campaignExcel', blob);
    //   })
    //   .catch((error) =>
    //     console.error('Error downloading the file:', error)
    //   );
  };

  const onAdvanceFilterChange = (filterValues: any) => {
    dispatch(handleFiltering(filterValues));
  };

  const handlePageChange = (current_page: number) => {
    dispatch(updateCurrentPage(current_page));
  };

  const pagination: TablePaginationConfig = {
    current: data?.meta?.current_page,
    pageSize: 10,
    total: data?.data?.totalCount,
    onChange: handlePageChange,
    showSizeChanger: false,
    position: ['bottomRight'],
  };

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    // console.log('selectedRowKeys changed: ', newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const isLoading = isFetching;
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  return (
    <>
      {/* <Button
      type="primary"
        onClick={() => {
          _navigate(routesName.ADDGROUP);
        }}
      >
        <PlusOutlined />
        {i18n.t("addGroup")}
      </Button> */}
      <Table
        rowSelection={rowSelection}
        filterComponent={
          <AdvanceFilter
            setAdvanceFilter={onAdvanceFilterChange}
            titleField={true}
          />
        }
        loading={isLoading}
        {...{ columns }}
        dataSource={data?.data?.conversations}
        pagination={pagination}
      ></Table>
    </>
  );
});
export { GroupsList };
